export default "__VITE_ASSET__BFlj0MP___"